<template>
  <el-dialog
    :title="title"
    :visible="is_visible"
    width="560px"
    @close="closeDialog"
  >
    <Alert
      v-if="!tableData.length"
      :text="emptyMessage"
      :type="'info'"
    />
  <DialogTable
      v-else
      :tableColumns="tableColumns"
      :tableData="tableData"
    />
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';
import Alert from 'Elements/Alert/Alert';
import DialogTable from 'Elements/Table/DialogTable';
import { getController } from '@/controllers/request';
import { store } from '@/store';

export default {
  props: {
    is_visible: {
      type: Boolean,
    }
  },
  data() {
    return {
      title: '',
      tableColumns: {},
      tableData: [],
      emptyMessage: 'UTM-метки отсутствуют',
    }
  },
  created() {
    const params = {
      module: 'HRPAC_UTM',
      action: 'getUtmList',
      hrpac_published_vacancy_id: this.currentVacancy.id.value,
      to_pdf: true,
    };

    getController({ params })
    .then((res) => {
      const { data, title } = res.data.data.data;

      this.title = title.main[0].lbl.value;
      this.tableColumns = data.title;
      this.tableData = data.rows;
    })
  },
  computed: {
    currentVacancy() {
      return store.state.publicator.selectedPublishedVacancy;
    }
  },
  methods: {
    closeDialog() {
      store.commit('publicator/setSelectedPublishedVacancy', null);
      store.commit('common/setVisibleDialog', {
        name: 'publicator_utm_list_dialog',
        val: false
      });
    }
  },
  components: {
    'el-dialog': Dialog,
    DialogTable,
    Alert,
  }
};
</script>
<style lang="scss" scoped>
</style>
  